import { Observable, combineLatest, distinctUntilChanged, map } from 'rxjs';

/**
 * STAFF-3. What the header SHOWS as signed in: a member (Cognito) or a
 * counselor or admin on a live password session (selectIsStaffSignedIn), who
 * used to come back from /analytics to "Login". Display only: every member
 * action keeps the member check, so a staff session never acts as a member.
 */
export function signedInDisplay$(
  member$: Observable<boolean | null | undefined>,
  staff$: Observable<boolean | null | undefined>
): Observable<boolean> {
  return combineLatest([member$, staff$]).pipe(
    map(([member, staff]) => !!member || !!staff),
    distinctUntilChanged()
  );
}
